import { useEffect, useState } from 'react';

function AuthTimer({ initialSeconds = 300, onExpire }) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);

  useEffect(() => {
    if (timeLeft <= 0) {
      if (onExpire) onExpire();   // 만료됐을 때 콜백 호출 (옵션)
      return;
    }

    const timerId = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    // 언마운트/변경 시 interval 정리
    return () => clearInterval(timerId);
  }, [timeLeft, onExpire]);

  // mm:ss 포맷으로 변환
  const minutes = String(Math.floor(timeLeft / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  return (
    <span style={{ whiteSpace: 'nowrap', color: timeLeft <= 10 ? 'red' : 'inherit' }}>
      {minutes}:{seconds}
    </span>
  );
}

export default AuthTimer;
